import { doGet, doPost } from '../services/http';
export const fetchGetCardsListApi = url => doGet(url);
export const fetchGetFavCardsApi = url => doGet(url);
export const fetchAddFavCardsApi = (url, data) => doPost(url, data);
export const fetchUserDetailsApi = url => doGet(url);
export const fetchUpdateUserDetailsApi = (url, data) => doPost(url, data);